import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import AllPackages from "./pages/AllPackages";
import PackageDetails from "./pages/PackageDetails";
import { GlobalStyles } from "./components/styled/global.styled";
import { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme } from "./components/styled/Theme";
import { Helmet } from "react-helmet";
import PaymentConfirmation from "./pages/PaymentConfirmation";
import { useEffect, useMemo, useRef, useState } from "react";
import Modal from "./components/Modal";
import { getCookie, getDomainName, setCookie } from "./utils/helpers";
import ErrorBoundary from "./components/ErrorBoundary";
// import TvodSubscribe from "./pages/TvodSubscribe";
import OtpVerification from "./pages/OtpVerification";
import { generateShortToken } from "./redux/payment/payment.utils";
import PaymentPage from "./pages/PaymentPage";
import TvodPaymentPage from "./pages/TvodPaymentPage";
import bingePlusFavicon from "./assets/bingeplusfavIcon32_32.png";
import iscreenFavicon from "./assets/iscreenfavIcon32_32.png";
import funprimeFavicon from "./assets/funprimefavIcon16_16.png";
import urduflixFavicon from "./assets/urduflixfavIcon32_32.png";
import rockstreamerFavicon from "./assets/rockstreamerfavIcon150_150.webp";

function App() {
  // const {theme} = useSelector((state) => state.theme);
  const theme = "dark";
  const titleRef = useRef(null);
  const favIconRef = useRef(null);
  // let title;
  // const title = window?.platform_info?.title;
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [portal, setPortal] = useState(null)
  const platform = queryParams.get("url");
  const contentId = queryParams.get("content_id");
  const isTvod = queryParams.get("tvod");
  const isGpSvod = queryParams.get("svod");
  const ref = queryParams.get("ref");
  const partner = queryParams.get("partner");
  const txnId = queryParams.get("txnId");

  // users clicking content via social media promotion content
  useEffect(() => {
    if (ref === "fbclick") {
      async function fetchData() {
        const tempToken = await generateShortToken();
        setCookie("hash", tempToken, 20);
      }
      fetchData();
      localStorage.setItem("reference", "fb-promotion");
    }
    if (ref === "entertainment") {
      navigate(`/`, {
        state: {
          country: "BD",
        },
      });
    }
  }, [ref, platform, navigate]);

  useEffect(() => {
    if (platform) {
      localStorage.setItem("platform", platform);
      titleRef.current = getDomainName(platform);
      if (titleRef.current === "iscreen") {
        favIconRef.current = iscreenFavicon;
      }
      if (titleRef.current === "funprime") {
        favIconRef.current = funprimeFavicon;
      }
      if (titleRef.current === "bingepluslive") {
        favIconRef.current = bingePlusFavicon;
      }
      if (titleRef.current === "urduflix") {
        favIconRef.current = urduflixFavicon;
      }

      favIconRef.current = rockstreamerFavicon;
    }
  }, [platform]);

  const portal = localStorage.getItem("platform");

  const closeModal = () => {
    window.location.replace(`https://${portal}`);
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (portal) {
      const scriptElement = document.createElement("script");
      scriptElement.src = `https://platform.rockstreamer.com/platform/${portal}.js`;
      scriptElement.async = true; // Set to true if the script should load asynchronously
      // Additional attributes or configurations for the script can be set here

      // Append the script element to the document's head or body
      document.head.appendChild(scriptElement); // Or use document.body.appendChild(scriptElement);
    }
  }, [portal]);

  useEffect(() => {
    const hash = queryParams.get("hash");
    const decodedToken = atob(hash);

    // Set Cookie
    if (hash) {
      setCookie("hash", decodedToken, 20);
    }
  }, [queryParams]);

  useEffect(() => {
    // Get Cookie
    const timer = setTimeout(() => {
      const hashValue = getCookie("hash");
      if (!hashValue && !ref) {
        console.log("entered to set modal true 2");
        setIsModalOpen(true);
      }
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [ref]);

  // if from tvod content, navigate to tvod-subscribe route
  useEffect(() => {
    if (contentId && isTvod) {
      navigate(`/tvod-subscribe/${contentId}`, {
        state: {
          cid: contentId,
          tvod: isTvod,
        },
      });
      localStorage.setItem("contentId", contentId);
      localStorage.setItem("isTvod", isTvod);
    }
  }, [navigate, contentId, isTvod]);

  // if from gpexclusive svod content, navigate to tvod-subscribe route
  useEffect(() => {
    if (contentId && isGpSvod) {
      navigate(`/tvod-subscribe/${contentId}`, {
        state: {
          cid: contentId,
          tvod: false,
        },
      });
      localStorage.setItem("contentId", contentId);
      localStorage.setItem("isTvod", false);
    }
  }, [navigate, contentId, isGpSvod]);

  // if from banglalink dcb, navigate to otp-verification route
  useEffect(() => {
    if (partner && txnId) {
      navigate(`/otp-verification`, {
        state: {
          partnerId: partner,
          transactionId: txnId,
        },
      });
    }
  }, [navigate, partner, txnId]);

  useEffect(() => {
    const handlePopState = () => {
      // if(contentId && isTvod)
      window.location.replace(`https://${portal}`);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate, portal]);

  return (
    <ErrorBoundary>
      <Helmet>
        <title>{titleRef.current}</title>
        <meta
          name="description"
          content={`${titleRef.current} is a streaming Web App Where you can play your favourite songs and videos`}
        />
        <link
          rel="icon"
          type="image/png"
          href={favIconRef.current}
          sizes="16x16"
        />
        <meta property="og:title" content={titleRef.current} />

        {/* <meta property="og:image" content={`${window?.platform_info?.logo}`} /> */}
      </Helmet>
      <ThemeProvider theme={theme === "dark" ? darkTheme : lightTheme}>
        <GlobalStyles />
        <div>
          {/* <button onClick={openModal}>Open Modal</button> */}
          <Modal isOpen={isModalOpen} onClose={closeModal}>
            <h2>Session Expired</h2>
            <p>Please Try Again</p>
          </Modal>
        </div>

        <Routes>
          {/* <Route exact path="/" element={<AllPackages />} /> */}
          <Route exact path="/" element={<PaymentPage />} />
          <Route exact path="/subscribe/:id" element={<PackageDetails />} />
          <Route
            exact
            path="/tvod-subscribe/:id"
            element={<TvodPaymentPage />}
          />
          <Route
            exact
            path="/otp-verification"
            element={<OtpVerification setIsModalOpen={setIsModalOpen} />}
          />
          <Route
            exact
            path="/payment/confirm/:status"
            element={<PaymentConfirmation />}
          />
        </Routes>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
